import { render, staticRenderFns } from "./accountInfoCard.vue?vue&type=template&id=472e3476&scoped=true"
import script from "./accountInfoCard.vue?vue&type=script&lang=js"
export * from "./accountInfoCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472e3476",
  null
  
)

export default component.exports